import { Option } from '@veeva/corgix/select';

/**
 * Utilities for rendering options in the UI (i.e. language options for LanguageField).
 * This is meant to abstract common logic such as sorting and converting data to options.
 */

const convertKeyLabelsToOptions = (keyLabels) => {
    const options = keyLabels.map(({ key, label }) => (
        <Option value={key} key={key} label={label}>
            {label ?? key}
        </Option>
    ));

    return options;
};

const sortChoices = (choices) => {
    return choices.sort((a, b) => {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
};

export const renderLocaleOptions = (locales) => {
    const keyLabels = Object.entries(locales).map(([key, label]) => {
        return { key, label: label ?? key };
    });

    return convertKeyLabelsToOptions(sortChoices(keyLabels));
};

export const renderLanguageOptions = (languages) => {
    const keyLabels = Object.entries(languages).map(([key, label]) => {
        return { key, label };
    });

    return convertKeyLabelsToOptions(sortChoices(keyLabels));
};

export const renderTimezoneOptions = (valueLabels) => {
    const keyLabels = valueLabels.map(({ value, label }) => {
        return { key: value, label };
    });

    return convertKeyLabelsToOptions(keyLabels);
};
